export const NO_OF_DECIMALS = 2 as number

export const EXAMPLE_NUMBER = 12345.67 as number
